module.exports = __webpack_public_path__ + "fonts/b326a98.otf";